
import { Component, Vue } from 'vue-property-decorator'
import {
  CreatePipeMaterial,
  UpdatePipeMaterial,
  DeletePipeMaterial,
  ListPipeMaterials
} from '@/api/baseData'
import { IPipeMaterial } from '@/api/types'

@Component({
  name: 'PipeMaterialTab'
})
export default class extends Vue {
  private list: IPipeMaterial[] = []
  private listLoading = false

  private dialogFormVisible = false
  private dialogStatus = ''
  private temp: IPipeMaterial = {
    id: -1,
    name: '',
  }

  private rules = {
    name: [{ required: true, message: '请输入管材名称', trigger: 'blur' }],
    code: [{ required: true, message: '请输入管材编码', trigger: 'blur' }],
    price: [{ required: true, message: '请输入管材价格', trigger: 'blur' }]
  }

  created() {
    this.getList()
  }

  private async getList() {
    this.listLoading = true
    try {
      const { data } = await ListPipeMaterials()
      this.list = data || []
    } catch (error) {
      console.error('获取管材列表失败', error)
    } finally {
      this.listLoading = false
    }
  }

  private resetTemp() {
    this.temp = {
      id: -1,
      name: '',
    }
  }

  private handleCreate() {
    this.resetTemp()
    this.dialogStatus = 'create'
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as any).clearValidate()
    })
  }

  private async createData() {
    (this.$refs.dataForm as any).validate(async(valid: boolean) => {
      if (valid) {
        try {
          await CreatePipeMaterial(this.temp)
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '创建管材成功',
            type: 'success',
            duration: 2000
          })
          this.getList()
        } catch (error) {
          console.error('创建管材失败', error)
        }
      }
    })
  }

  private handleUpdate(row: any) {
    this.temp = Object.assign({}, row)
    this.dialogStatus = 'update'
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as any).clearValidate()
    })
  }

  private async updateData() {
    (this.$refs.dataForm as any).validate(async(valid: boolean) => {
      if (valid) {
        const tempData = Object.assign({}, this.temp)
        try {
          if (tempData.id !== undefined) {
            const updateData = {
              id: Number(tempData.id),
              name: tempData.name,
            }
            await UpdatePipeMaterial(updateData)
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新管材成功',
              type: 'success',
              duration: 2000
            })
            this.getList()
          }
        } catch (error) {
          console.error('更新管材失败', error)
        }
      }
    })
  }

  private async handleDelete(row: any) {
    this.$confirm('确认删除该管材?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async() => {
      try {
        await DeletePipeMaterial({ id: row.id })
        this.$notify({
          title: '成功',
          message: '删除管材成功',
          type: 'success',
          duration: 2000
        })
        this.getList()
      } catch (error) {
        console.error('删除管材失败', error)
      }
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消删除'
      })
    })
  }
}
